<template>
  <div class="col-12 sector invoice-sector px-3">
    <div class="row">
      <div class="sector__header">
        {{ t("coins.title") }}
      </div>
      <div class="sector__content">
        <div class="row">
    		  <div class="col-12 col-md-2">
            <label>{{ t("coins.yourCoins") }}:</label>
          </div>
          <div class="col-12 col-md-10">
            <label>
              {{ data.account_coin }} <span class="text-primary">
                ({{ $t("coins.maxCoins", coinDiscountLimit, [coinDiscountLimit]) }})
              </span>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-2"><label>{{ t("coins.useCoin") }}:</label></div>
          <div class="col-12 col-md-10">
            <el-form-item 
              prop="coin_discount"
              :rules="[
                { type: 'number', min: 0, max: coinDiscountLimit, message: '佣金不足' },
              ]"
            >
              <el-input 
                v-model.number="form.coin_discount" 
                type="number"
                :min="0"
                :max="coinDiscountLimit"
                size="large"
              >
                <template #append>
                  <el-button type="primary" :disabled="!coinDiscountLimit" size="large" @click="setAllCoinDiscount(codeFormRef)">
                    {{ t("coins.useAllCoin") }}
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
            <div class="input-group" hidden>
              <input name="coin_discount" type="number" class="form-control" :min="0" :max="coinDiscountLimit" v-model.number="form.coin_discount" >
              <button class="btn btn-primary" type="button" @click="setAllCoinDiscount">{{ t("coins.useAllCoin") }}</button>
            </div>
            

            <p class="hint">{{ t("coins.useHint") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { useVModel } from '@vueuse/core'

const props = defineProps({
  modelValue: Object,
  data: Object,
  coinDiscountLimit: Number,
})
const emit = defineEmits(['update:modelValue'])

const { t, locale } = useI18n()
const form = useVModel(props, 'modelValue', emit)

const setAllCoinDiscount = () => {
  form.value.coin_discount = props.coinDiscountLimit.value;
}
</script>
